import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styles from './ApprovalFormModal.module.scss';
import { baseApiCall } from 'src/api/Api';
import { commonVaribles } from 'src/constants/constVariables';
import { Button, FileInputSection } from 'src/components';
import {
	packaging_strategy_all_endpoints,
	user_management_service,
} from 'src/constants/url';
import useAuthorizationContext from 'src/providers/AuthorizationHandler/useAuthorizationContext';
import Select from 'react-select';
import { Regex } from 'src/constants/constant';
import { IsUserRoleMatch } from 'src/constants/utils';
import { onResponse } from 'src/redux/features';
import * as XLSX from 'xlsx';

export const ApprovalFormModal = ({
	handleClose,
	open,
	rowData,
	id,
	plantId,
}) => {
	const { user } = useAuthorizationContext();

	const approvalStatusArray = [
		{ label: 'Approve', value: 'approved' },
		{ label: 'Reject', value: 'rejected' },
	];

	const incoTerm = rowData?.inco_terms;
	const scmStatus = rowData?.scm_approval_status;
	const logisticsStatus = rowData?.logistics_approval_status;
	const scmEvaluatedId = rowData?.scm_buyer_status_evaluated_id;
	const logisticsEvaluatedId = rowData?.logistics_buyer_status_evaluated_id;
	const dmpStatus = approvalStatusArray.find((option) => option?.value === rowData?.dmp_approval_status);

	const [isButtonDisable, setIsButtonDisable] = useState(true);
	const [isApprovedStatus, setApprovedStatus] = useState(false);
	const [isCostVisibleStatus, setCostVisibleStatus] = useState(false);
	const [isSettledCostVisibleStatus, setSettledCostVisibleStatus] = useState(false);

	const [selectedImage, setSelectedImage] = useState({});
	const [isImage, setIsImage] = useState(false);

	const [packagingDetails, setPackagingDetails] = useState({ attachment: '' });

	const formValid = () => {
		const {
			selected_approval_status,
			selected_assigned_scm_buyer,
			selected_assigned_logistics_buyer,
			tml_packaging_cost,
			tml_transportation_cost,
			remark
		} = approvalData;
		if (!IsUserRoleMatch('direct_material_buyer_user', user)) {
			if (selected_approval_status?.value == 'approved') {
				setCostVisibleStatus(false);
				setSettledCostVisibleStatus(true);
				return (
					selected_approval_status.label &&
					!errorMessage.selected_approval_status
				);
			} else if (selected_approval_status?.value == 'rejected') {
				setCostVisibleStatus(true);
				setSettledCostVisibleStatus(false);
				if (IsUserRoleMatch('logistics_buyer_user', user)) {
					return (
						selected_approval_status.label &&
						remark &&
						tml_packaging_cost &&
						tml_transportation_cost &&
						!errorMessage.selected_approval_status &&
						!errorMessage.remark &&
						!errorMessage.tml_packaging_cost &&
						!errorMessage.tml_transportation_cost
					);
				}
				return (
					selected_approval_status.label &&
					remark &&
					!errorMessage.selected_approval_status &&
					!errorMessage.remark
				);
			}
		}
		if (selected_approval_status?.value == 'approved') {
			return (
				selected_approval_status.label &&
				selected_assigned_scm_buyer.label &&
				selected_assigned_logistics_buyer.label &&
				!errorMessage.selected_approval_status &&
				!errorMessage.selected_assigned_scm_buyer &&
				!errorMessage.selected_assigned_logistics_buyer
			);
		}
		return (
			selected_approval_status.label &&
			remark &&
			!errorMessage.selected_approval_status &&
			!errorMessage.remark
		);
	};

	const [approvalData, setApprovalData] = useState({
		selected_approval_status: (IsUserRoleMatch('direct_material_buyer_user', user) && dmpStatus) || {},
		selected_assigned_scm_buyer: {},
		selected_assigned_logistics_buyer: {},
		assigned_scm_buyer_list: [],
		assigned_logistics_buyer_list: [],
		tml_packaging_cost: '',
		tml_transportation_cost: '',
		tml_settled_packaging_cost: '',
		tml_settled_transportation_cost: '',
		remark: ''
	});

	const [errorMessage, setErrorMessage] = useState({
		assigned_scm_buyer_id: false,
		assigned_logistics_buyer_id: false,
		tml_packaging_cost: false,
		tml_transportation_cost: false,
		tml_settled_packaging_cost: false,
		tml_settled_transportation_cost: false,
		remark: false,
		attachment_file: false,
	});

	useEffect(() => {
		setIsButtonDisable(!formValid());
	}, [approvalData, errorMessage, formValid]);

	const confirmUpload = (e) => {
		setIsButtonDisable(true);
		e.preventDefault();
		const approvalFormRequestBody = {
			strategy_id: id,
			assigned_scm_buyer_id: approvalData?.selected_assigned_scm_buyer?.value,
			assigned_logistics_buyer_id:
				approvalData?.selected_assigned_logistics_buyer?.value,
			tml_packaging_cost:
				approvalData?.selected_approval_status?.value !== 'approved'
					? approvalData?.tml_packaging_cost
					: '',
			tml_transportation_cost:
				approvalData?.selected_approval_status?.value !== 'approved'
					? approvalData?.tml_transportation_cost
					: '',
			tml_settled_packaging_cost:
				approvalData?.selected_approval_status?.value == 'approved'
					? approvalData?.tml_settled_packaging_cost
					: '',
			tml_settled_transportation_cost:
				approvalData?.selected_approval_status?.value == 'approved'
					? approvalData?.tml_settled_transportation_cost
					: '',
			remark: approvalData?.remark,
			approval_status: approvalData?.selected_approval_status?.value,
			remark_attachment: isImage,
			file_type: selectedImage?.name?.split('.')?.pop()
		};

		baseApiCall({
			url: packaging_strategy_all_endpoints.POST_STRATEGY_ADD_APPROVAL_STATUS,
			requestBody: approvalFormRequestBody,
			method: commonVaribles.post,
			onSuccess: (res) => {
				if (res && res.data && res.data.status === 201) {
					const presigned_url = res?.data?.result;
					if (presigned_url && selectedImage?.name) {
						const blobFile = selectedImage;
						const xhr = new XMLHttpRequest();
						xhr.open('PUT', presigned_url, true);
						xhr.setRequestHeader('Content-Type', blobFile.type);
						xhr.onload = function () {
							if (xhr.status >= 200 && xhr.status < 300) {
								setSelectedImage(null);
								closeFunction();
								setIsButtonDisable(false);
								onResponse({
									isToaster: true,
									severity: commonVaribles.success,
									message: commonVaribles.file_upload_successfully,
								});
							} else {
								closeFunction();
								setIsButtonDisable(false);
								onResponse({
									isToaster: true,
									severity: commonVaribles.error,
									message: commonVaribles.file_upload_failed,
								});
							}
						};
						xhr.onerror = function () {
							closeFunction();
							setIsButtonDisable(false);
							onResponse({
								isToaster: true,
								severity: commonVaribles.error,
								message: commonVaribles.file_upload_failed,
							});
						};
						xhr.send(blobFile);
					}
				} else {
					closeFunction();
					setIsButtonDisable(false);
				}
			},
			onFailure: (res) => {
				setIsButtonDisable(false);
			},
			errorCall: (res) => {
				setIsButtonDisable(false);
			},
		});
	};

	const closeFunction = () => {
		handleClose();
	};

	const customStyle = {
		control: (provided, state) => ({
			...provided,
			minHeight: '2rem',
		}),
		indicatorSeparator: (state) => ({
			display: 'none',
		}),
		singleValue: (provided) => ({
			...provided,
			color: 'none',
		}),
	};

	const handleSelectChange = (value, name) => {
		switch (name) {
			case 'selected_assigned_scm_buyer':
				break;
			case 'selected_assigned_logistics_buyer':
				setErrorMessage((prev) => ({
					...prev,
				}));
				break;
			case 'selected_approval_status':
				if (value?.value == 'approved') {
					if (IsUserRoleMatch('direct_material_buyer_user', user)) {
						setApprovedStatus(true);
						fetchUserRoleWiseList();
					} else {
						setApprovedStatus(false);
					}
				} else {
					setApprovedStatus(false);
					setApprovalData((prev) => ({
						...prev,
						selected_assigned_scm_buyer: {},
						selected_assigned_logistics_buyer: {}
					}));
				}
				setErrorMessage((prev) => ({
					...prev,
				}));
				break;
			default:
				break;
		}
		setApprovalData((prev) => ({
			...prev,
			[name]: value,
		}));
	};

	useEffect(() => {
		// Check dmpStatus and user role on initial render
		if (
			IsUserRoleMatch('direct_material_buyer_user', user) &&
			dmpStatus?.value === 'approved'
		) {
			setApprovedStatus(true);
			fetchUserRoleWiseList();
		} else {
			setApprovedStatus(false);
		}
	}, []);

	const handleInputChange = (event) => {
		const { name, value } = event.target;
		// event.target.value.trim();
		setApprovalData((prev) => ({
			...prev,
			[name]: value,
		}));
		if (
			(!Regex.remark.test(value) && name === 'remark' && value !== '') ||
			(!Regex.cost_no.test(value) &&
				name === 'tml_packaging_cost' &&
				value !== '') ||
			(!Regex.cost_no.test(value) &&
				name === 'tml_transportation_cost' &&
				value !== '')
		) {
			setErrorMessage((prev) => ({
				...prev,
				[name]: true,
			}));
		} else {
			setErrorMessage((prev) => ({
				...prev,
				[name]: false,
			}));
		}
	};

	const fetchUserRoleWiseList = () => {
		const req_user_role_names = ['SCM Buyer', 'Logistics Purchase Buyer'];
		baseApiCall({
			url: user_management_service.GET_USER_ROLE_DETAILS_BY_ROLE,
			requestBody: {
				user_role_names: req_user_role_names,
				is_dropdown_value: true
			},
			method: commonVaribles.post,
			onSuccess: (res) => {
				if (res && res.data && res.data.result && res.data.result !== '') {
					const data = res.data.result;
					const scmOption = data?.[req_user_role_names[0]].find((option) => option?.value === scmEvaluatedId);
					const logisticsOption = data?.[req_user_role_names[1]].find((option) => option?.value === logisticsEvaluatedId);

					setApprovalData((prev) => ({
						...prev,
						assigned_scm_buyer_list: data?.[req_user_role_names[0]],
						assigned_logistics_buyer_list: data?.[req_user_role_names[1]],
						selected_assigned_scm_buyer: scmOption || {},
						selected_assigned_logistics_buyer: logisticsOption || {}
					}));
				} else {
				}
			},
			onFailure: () => {},
			errorCall: () => {},
		});
	};

	// Handle file upload change for both image and excel
	const handleFileChange = (event) => {
		event.preventDefault();
		const { name, files } = event.target;
		const file = files[0];

		// Check if it's an image or an Excel file
		const isImageFile = file && file?.type?.startsWith('image/');
		const isExcelFile =
			file &&
			(file?.type?.includes('excel') || file?.type?.includes('spreadsheetml'));

		// If it's an image file
		if (isImageFile) {
			const reader = new FileReader();
			reader.onloadend = () => {
				let base64String = reader.result;
				base64String = base64String.replace(/^data:image\/[a-z]+;base64,/, ''); // Clean base64 string
				setPackagingDetails((prev) => ({
					...prev,
					[name]: base64String,
					[`${name}_preview`]: base64String,
					//   [`${name}_preview`]: URL.createObjectURL(file),
				}));
				setIsImage(true);
				setSelectedImage(file);
			};
			reader.readAsDataURL(file); // Convert image to base64
		}

		// If it's an Excel file
		else if (isExcelFile) {
			// You can handle Excel file reading here, for example:
			setPackagingDetails((prev) => ({
				...prev,
				[name]: file.name,
			}));
			const reader = new FileReader();
			reader.onload = (event) => {
				const binaryStr = event.target.result;
				const wb = XLSX.read(binaryStr, { type: 'binary' });

				// Extract first sheet and convert it to JSON
				const sheetName = wb.SheetNames[0];
				const sheet = wb.Sheets[sheetName];
				const sheetData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

				setPackagingDetails((prev) => ({
					...prev,
					[`${name}_preview`]: sheetData, // Store Excel content in state
				}));
				setIsImage(true);
				setSelectedImage(file);
			};
			reader.readAsBinaryString(file); // Read the Excel file
		}

		setIsButtonDisable(false); // Enable submit button after a valid file is selected
	};

	return (
		<Modal open={open} onClose={handleClose} className={styles.modalstyle}>
			<>
				<div className={styles.modalTablecontainer}>
					<div className={styles.closeIconContainerStyle}>
						<div className={styles.HeaderwithCloseIcon}>
							<div className={styles.header}>
								<div className={styles.subheader}>
									<span className={styles.ModalTitle}>Approval Form</span>
								</div>
							</div>
							<div className={styles.closeIconStyle}>
								<CloseIcon
									onClick={closeFunction}
									//sx={{ backgroundColor: "#E8E8E8" }}
								/>
							</div>
						</div>
					</div>
					<div className={styles.submodalsection}>
						<form>
							{IsUserRoleMatch('logistics_buyer_user', user) && (
								<div className={styles['plantlocation']}>
									{/* Add a class name for styling */}
									<label className={styles['plant-location-label']}>
										INCO Terms
									</label>
									<div className={styles.incoTermValue}>
										<label>{incoTerm ? incoTerm : '-'}</label>
									</div>
								</div>
							)}

							<div className={styles['plantlocation']}>
								{/* Add a class name for styling */}
								<label className={styles['plant-location-label']}>
									Select Approval Status*
								</label>
								<div className={styles['user-group']}>
									<Select
										className={styles['input-box']}
										styles={customStyle}
										options={approvalStatusArray}
										onChange={(e) =>
											handleSelectChange(e, 'selected_approval_status')
										}
										value={approvalData?.selected_approval_status}
										isDisabled={
											IsUserRoleMatch('direct_material_buyer_user', user) &&
											(dmpStatus?.value == 'approved' ||
												dmpStatus?.value == 'rejected')
										}
									/>
								</div>
							</div>

							{isApprovedStatus && (
								<>
									<div className={styles['plantlocation']}>
										{/* Add a class name for styling */}
										<label className={styles['plant-location-label']}>
											Assigned To SCM*
										</label>
										<div className={styles['user-group']}>
											<Select
												className={styles['input-box']}
												styles={customStyle}
												options={approvalData.assigned_scm_buyer_list}
												onChange={(e) =>
													handleSelectChange(e, 'selected_assigned_scm_buyer')
												}
												isDisabled={
													IsUserRoleMatch('direct_material_buyer_user', user) &&
													(scmStatus == 'approved' || scmStatus == 'rejected')
												}
												value={approvalData?.selected_assigned_scm_buyer}
											/>
										</div>
									</div>
									<div className={styles['plantlocation']}>
										{/* Add a class name for styling */}
										<label className={styles['plant-location-label']}>
											Assigned To Logistics Buyer*
										</label>
										<div className={styles['user-group']}>
											<Select
												className={styles['input-box']}
												styles={customStyle}
												options={approvalData.assigned_logistics_buyer_list}
												onChange={(e) =>
													handleSelectChange(
														e,
														'selected_assigned_logistics_buyer'
													)
												}
												isDisabled={
													IsUserRoleMatch('direct_material_buyer_user', user) &&
													(logisticsStatus == 'approved' ||
														logisticsStatus == 'rejected')
												}
												value={approvalData?.selected_assigned_logistics_buyer}
											/>
										</div>
									</div>
								</>
							)}
							{IsUserRoleMatch('logistics_buyer_user', user) &&
								isCostVisibleStatus && (
									<>
										<div className={styles['']}>
											<div className={styles['plantlocation']}>
												<label className={styles['plant-location-label']}>
													Packaging Cost*
												</label>
												<div className={styles['user-group']}>
													<input
														className={styles['text-box']}
														value={approvalData?.tml_packaging_cost}
														pattern="^\d{10}$"
														name="tml_packaging_cost"
														onChange={(event) => handleInputChange(event)}
													/>
												</div>
											</div>
											<div>
												{errorMessage.tml_packaging_cost && (
													<span className={styles['errormsg']}>
														{commonVaribles.errorMsgForCostNo}
													</span>
												)}
											</div>
										</div>
										<div className={styles['']}>
											<div className={styles['plantlocation']}>
												<label className={styles['plant-location-label']}>
													Transportation Cost*
												</label>
												<div className={styles['user-group']}>
													<input
														className={styles['text-box']}
														value={approvalData?.tml_transportation_cost}
														pattern="^\d{10}$"
														name="tml_transportation_cost"
														onChange={(event) => handleInputChange(event)}
													/>
												</div>
											</div>
											<div>
												{errorMessage.tml_transportation_cost && (
													<span className={styles['errormsg']}>
														{commonVaribles.errorMsgForCostNo}
													</span>
												)}
											</div>
										</div>
									</>
								)}

							{IsUserRoleMatch('logistics_buyer_user', user) &&
								isSettledCostVisibleStatus && (
									<>
										<div className={styles['']}>
											<div className={styles['plantlocation']}>
												<label className={styles['plant-location-label']}>
													TML Settled Packaging Cost
												</label>
												<div className={styles['user-group']}>
													<input
														className={styles['text-box']}
														value={approvalData?.tml_settled_packaging_cost}
														pattern="^\d{10}$"
														name="tml_settled_packaging_cost"
														onChange={(event) => handleInputChange(event)}
													/>
												</div>
											</div>
											<div>
												{errorMessage.tml_settled_packaging_cost && (
													<span className={styles['errormsg']}>
														{commonVaribles.errorMsgForCostNo}
													</span>
												)}
											</div>
										</div>
										<div className={styles['']}>
											<div className={styles['plantlocation']}>
												<label className={styles['plant-location-label']}>
													TML Settled Transportation Cost
												</label>
												<div className={styles['user-group']}>
													<input
														className={styles['text-box']}
														value={
															approvalData?.tml_settled_transportation_cost
														}
														pattern="^\d{10}$"
														name="tml_settled_transportation_cost"
														onChange={(event) => handleInputChange(event)}
													/>
												</div>
											</div>
											<div>
												{errorMessage.tml_settled_transportation_cost && (
													<span className={styles['errormsg']}>
														{commonVaribles.errorMsgForCostNo}
													</span>
												)}
											</div>
										</div>
									</>
								)}
							<div className={styles['comments']}>
								{/* Add a class name for styling */}
								<label className={styles['comments-label']}>
									Please specify your remarks{' '}
									{approvalData?.selected_approval_status?.value != 'approved'
										? '*'
										: '(If any)'}
								</label>
								<textarea
									className={styles['comments-textarea']}
									rows="8"
									name="remark"
									placeholder="Enter your remark here..."
									onChange={(event) => handleInputChange(event)}
								></textarea>
								{errorMessage.remark && (
									<span className={styles['errormsg']}>
										{commonVaribles.errorMsgForMobileNumber}
									</span>
								)}
							</div>

							<div className={styles['image-upload-div']}>
								<label className={styles['form-label']}>
									Upload Image or Excel File
								</label>
								<div className={styles['user-group']}>
									<FileInputSection
										name="attachment"
										onChange={handleFileChange}
										editName="Uploaded File"
										isEdited={false}
										fileURL={packagingDetails.attachment_preview}
										acceptTypes="image/png, image/jpg, image/jpeg, .xls, .xlsx, .xlsm" // Accept both image and Excel files
									/>
								</div>
								{errorMessage.attachment_file && (
									<span className={styles['errormsg']}>
										{errorMessage.attachment_file}
									</span>
								)}
							</div>

							{/* Add a class name for styling */}
							<div className={styles.imageuploadsection}>
								<div className={styles['button-section']}>
									<Button
										variant="primary"
										onClick={(e) => {
											confirmUpload(e);
										}}
										disabled={isButtonDisable}
									>
										Submit Form
									</Button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</>
		</Modal>
	);
};

ApprovalFormModal.propTypes = {
	open: PropTypes.bool.isRequired,
	handleClose: PropTypes.func.isRequired,
};
